import { MergeCellsOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client'
import { Button, Form, message, Modal, Typography } from 'antd'
import * as PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLoginModal } from '../../../../context/loginModalContext'
import { showAuthError } from '../../../../shared/utils/webHelpers'
import SearchField from '../../../common/searchFields/SearchField'
import MERGE_LAB from '@dentolize/clinic-mobile/src/shared/store/mutations/actions/labs/mergeLab'
import { SEARCH_LABS_QUERY } from '@dentolize/clinic-mobile/src/shared/store/queries/appointmentQueries'

/** Merges a lab into another, which takes its items and orders, in place of deleting it with them */
const MergeLabButton = ({ lab, disabled, afterMerge }) => {
  const { t } = useTranslation()
  const { setLoginModalVisible } = useLoginModal()
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false)

  const [mergeLab, { loading }] = useMutation(MERGE_LAB, {
    update: store => store.data.delete(`Lab:${lab.id}`),
    refetchQueries: [{ query: SEARCH_LABS_QUERY, variables: { searchTerm: '' } }]
  })

  const handleSubmit = () =>
    form.validateFields().then(async values => {
      if (values.lab?.key === lab.id) {
        message.error(t('app.mergeError'))
        return
      }
      try {
        await mergeLab({ variables: { lab: lab.id, newLab: values.lab.key } })
        message.success(t('common.updatedSuccessfully'))
        setVisible(false)
        afterMerge && afterMerge()
      } catch (e) {
        showAuthError(e, t, setLoginModalVisible)
      }
    })

  return (
    <>
      <Button
        disabled={disabled}
        icon={<MergeCellsOutlined />}
        onClick={() => {
          form.resetFields()
          setVisible(true)
        }}
      >
        {t('app.mergeGroup')}
      </Button>
      <Modal
        open={visible}
        title={t('app.mergeGroup')}
        onCancel={() => setVisible(false)}
        onOk={handleSubmit}
        okText={t('common.save')}
        cancelText={t('common.cancel')}
        confirmLoading={loading}
        destroyOnClose
      >
        <Typography.Paragraph type="warning">{t('app.mergeLabDesc')}</Typography.Paragraph>
        <Form form={form} layout="vertical">
          <SearchField
            GET_QUERY={SEARCH_LABS_QUERY}
            label={t('app.lab')}
            fieldName="lab"
            dataName="searchLabs"
            disableAddNew
            rules={[{ required: true, message: t('app.pleaseSelectGroup') }]}
          />
        </Form>
      </Modal>
    </>
  )
}

MergeLabButton.propTypes = {
  lab: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  afterMerge: PropTypes.func
}

export default MergeLabButton
